import React, { useState, useEffect } from "react";
import { Redirect } from "react-router";
import TopBar from "../../Components/topBar/topBar";
import BottomBar from "../../Components/bottomBar/bottomBar";
import CardMachine from "../../Components/cardMachine/cardMachineOrigin";
import Dropdown from "../../Components/dropDown/dropDown";
import Alert from "../../Components/alert/Alert";
import Spinner from "react-bootstrap/Spinner";
import styles from "../General/details.module.css";
import Select from '../../Components/select/select';
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Api from "../../services/api";
import "./dashboard.css";
import "./dashboardTV.css";

const Main = () => {
  const [loading, setLoading] = useState(true);
  const [machines, setMachines] = useState([]);
  const [machinesSelect, setMachinesSelect] = useState([{ value: "Todos", label: "Todos" }]);
  const [show, setShow] = useState(false);
  const [machinesInitial, setMachinesInitial] = useState([]);
  const [message, setMessage] = useState("");
  const [departments, setDepartments] = useState([{ value: "Todos", label: "Todos" }]);
  const [status, setStatus] = useState([
    { value: "Todos", label: "Todos" },
    { value: null, label: "Máquina desligada" },
    { value: true, label: "Máquina produzindo" },
    { value: false, label: "Máquina parada" },
    { value: 2, label: "Sem Operador" },
    { value: 3, label: "Parada programada" }
  ]);
  const [statusId, setStatusId] = useState([
    { value: "Todos", label: "Todos" },
    { value: null, label: "Máquina desligada" },
    { value: true, label: "Máquina produzindo" },
    { value: false, label: "Máquina parada" },
    { value: 2, label: "Sem Operador" },
    { value: 3, label: "Parada programada" }
  ]);
  const [departmentsId, setDepartmentsId] = useState([]);
  const [dashboard, setDashboard] = useState(true);
  const [messageDash, setMessageDash] = useState("Nenhuma máquina em monitoramento para este setor.");
  const [redirect, setRedirect] = useState(false);
  const [reload, setReload] = useState(false);
  const [toastArray, setToastArray] = useState([]);
  const [factorys, setFactorys] = useState([{ value: "Todos", label: "Todos" }]);
  const [idFactorys, setIdFactorys] = useState([]);
  const [dash, setDash] = useState(false);
  const [machinesDisplay, setMachinesDisplay] = useState([]);
  const [classMachinesDisplay, setClassMachinesDisplay] = useState("");
  const [date, setDate] = useState(null);
  const [hour, setHour] = useState(null);
  const [workshift, setWorkshift] = useState("Turno");
  const [back, setBack] = useState(false);

  const fetchData = async () => {
    await getAllMachines();

    Api.get("/factorys/").then((response) => {
      let arr = [];
      response.data.forEach((element) => {
        arr.push({ value: element.description, label: element.description });
      });
      setFactorys((prevFactorys) => [...prevFactorys, ...arr]);
      setIdFactorys(response.data);
    });

    Api.get("/departments/")
      .then((resp) => {
        setDepartmentsId(resp.data);
      })
      .catch((error) => {
        setMessage("Erro de conexão com o servidor.");
        setShow(true);
        setReload(true);
      });

    // Função para atualizar a cada 5 minutos a página de dashboard.
    const intervalId = setInterval(() => {
      window.location.reload();
    }, 300000);

    return () => clearInterval(intervalId);
  };

  useEffect(() => {

    fetchData();
  }, []);

  const getAllMachines = async () => {
    Api.get("/track-machines/list/")
      .then((response) => {
        if (response.data.error !== undefined) {
          alert(JSON.stringify(response.data.error));
        } else {
          if (response.data.length === 0 || response.status === 205) {
            setDashboard(false);
            setDash(true);
            setMessageDash("Nenhuma máquina ou turno ativo.");
            setLoading(false);
          } else {
            let machines = [];

            response.data.sort((a, b) => {
              if (a.statusData.status === true && b.statusData.status === 2) return -1;
              if (a.statusData.status < b.statusData.status) return 1;
              if (a.statusData.status > b.statusData.status) return -1;
              if (a.statusData.status === false && b.statusData.status === null) return -1;
              return 0;
            });

            response.data.forEach((element) => {
              machines.push({ value: element.id, label: `${element.description} ${element.code}` });
            });

            setMachines(response.data);
            setMachinesSelect(machines);
            setMachinesInitial(response.data);
            setDashboard(true);
            setDash(true);
            setLoading(false);
          }
        }
      })
      .catch(() => {
        setMessage("Erro de conexão com o servidor.");
        setShow(true);
        setDashboard(false);
        setReload(true);
        setLoading(false);
      });
  };

  const callbackFunction = () => {
    setShow(false);
  };

  const notifyAction = (value) => {
    setToastArray((prevToastArray) => [...prevToastArray, value]);
  };

  useEffect(()=>{
    if(machines.length > 0){
      let numPags = Math.ceil(machines.length/10);
      let aux = 0;
      let auxArr = [];
      let auxPag = [];

      if(machines.length < 10){
        auxPag = machines;
        auxArr.push(auxPag);
      }else{
        machines.forEach((element)=>{
          if(aux == 10){
            auxArr.push(auxPag);
            aux = 0;
            auxPag = [];
          }
          auxPag.push(element);
          aux++;
        });

        if(auxPag.length > 0){
          auxArr.push(auxPag);
        }
      }      

      exchanger(auxArr);

    }
  },[machines])

  const exchanger = (arr)=>{

    let aux = 1;

    if(arr[aux-1].length >= 10){
      setClassMachinesDisplay("machine-tracking-container-columns-5");
    }

    if(arr[aux-1].length <= 8){
      setClassMachinesDisplay("machine-tracking-container-columns-4");
    }

    if(arr[aux-1].length <= 6){
      setClassMachinesDisplay("machine-tracking-container-columns-3");
    }

    if(arr[aux-1].length <= 4){
      setClassMachinesDisplay("machine-tracking-container-columns-2");
    }

    if(arr[aux-1].length <= 2){
      setClassMachinesDisplay("machine-tracking-container-columns-1");
    }
    
    setMachinesDisplay(arr[aux-1]);
    setInterval(()=>{
      if(aux == arr.length){
        aux = 1;
      }else{
        aux++;
      }
      setMachinesDisplay(arr[aux-1]);

      if(arr[aux-1].length >= 10){
        setClassMachinesDisplay("machine-tracking-container-columns-5");
      }

      if(arr[aux-1].length <= 8){
        setClassMachinesDisplay("machine-tracking-container-columns-4");
      }

      if(arr[aux-1].length <= 6){
        setClassMachinesDisplay("machine-tracking-container-columns-3");
      }

      if(arr[aux-1].length <= 4){
        setClassMachinesDisplay("machine-tracking-container-columns-2");
      }

      if(arr[aux-1].length <= 2){
        setClassMachinesDisplay("machine-tracking-container-columns-1");
      }

    },3000)
  }

  const workshiftAtt = ()=>{
    Api.get("/work-shifts/curshift/ ").then((response)=>{
      console.log(response);
        setWorkshift(response.data.code + " (" + response.data.start_time + " até " + response.data.end_time + ")");
    }).catch((error)=>{
      console.log(error)
    })
}

  useEffect(()=>{       
    workshiftAtt();
    setDateHour();

    setInterval(()=>{
        setDateHour();
    }, 1000);

    setInterval(()=>{
      workshiftAtt();
  },10000)

  setInterval(()=>{
    getAllMachines();
},60000)
}, [])

  const  setDateHour = ()=>{
    let completeDate = new Date();
    let day = null;
    let month = null;
    let hours = null;
    let minutes = null;
    let seconds = null;

    if(completeDate.getDate() < 10){
        day = "0" + completeDate.getDate();
    }else{
        day = completeDate.getDate();
    }


    if(completeDate.getMonth() + 1 < 10){
        
        month = "0" + parseInt(completeDate.getMonth() + 1);
    }else{
        month =  completeDate.getMonth() + 1;
    }

    if(completeDate.getHours() < 10){
        hours = "0" + completeDate.getHours();
    }else{
        hours = completeDate.getHours();
    }

    if(completeDate.getMinutes() < 10){
        minutes = "0" + completeDate.getMinutes();
    }else{
        minutes = completeDate.getMinutes();
    }

    if(completeDate.getSeconds() < 10){
        seconds = "0" + completeDate.getSeconds();
    }else{
        seconds = completeDate.getSeconds();
    }

    setDate(day + "/" + month + "/" + completeDate.getFullYear());
    setHour(hours + ":" + minutes + ":" + seconds);
}   

  if (redirect) return <Redirect to="/" />;

  return (
    <>
    {(back == true) ? (<Redirect to={{pathname: "/dashboard"}}/>):(<></>)}
      <header>
        {show && <Alert show={show} message={message} parentCallback={callbackFunction} reload={reload} />}
      </header>
      <main className="mainDashboardTv">
        <div className="topLineDashboardTv">
        <span className="backButtonText" onClick={()=>{setBack(true)}}>← Voltar</span> Dashboard - {date} - {hour} - {workshift}
        </div>
        <div className="border menu-container menu-container-tv" style={{ textAlign: "2vh" }}>
          <div className="machine-tracking-container machine-tracking-container-tv" style={{ alignItems: 'center', justifyContent: 'center' }}>
            {loading ? (
              <div className={styles.loader}>
                <Spinner variant="success" animation="border" />
                <strong>Carregando...</strong>
              </div>
            ) : dashboard ? (
              <div className={"machine-tracking-container machine-tracking-container-tv "+ classMachinesDisplay} style={{ alignItems: 'center', justifyContent: 'center' }}>
                {machinesDisplay.map((item) => (
                  <div key={item.id} id={item.id} className="dashboardTV">
                    <CardMachine
                      id={item.id}
                      statusData={item.statusData}
                      oeeData={item.oeeData}
                      notifyAction={notifyAction}
                      machine={`${item.description} ${item.code}`}
                      oeeGoal={item.oee_goal}
                    />
                  </div>
                ))}
              </div>
            ) : (
              <div className="messageDash">
                <h3>{messageDash}</h3>
              </div>
            )}
          </div>
        </div>
      </main>
    </>
  );
};

export default Main;